<template>
  <!-- 概览 -->
  <div class="mine-overview">
    <!-- 用户信息 -->

    <div class="user-meta">
      <div v-if="userData[0]?.image" class="avatar">
        <img :src="userData[0]?.image" />
      </div>
      <span
        v-else
        style="font-size: 50px; color: #fff; margin-left: 60px"
        class="iconfont icon-yixue"
      ></span>
      <h4>
        {{ userData[0]?.nickName }}
      </h4>
    </div>
  </div>
</template>
<script>
export default {
  name: "MineOverview",
  props: {
    userData: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped lang="less">
.mine-overview {
  height: 132px;
  background: url(../../../../../public/imgs/user-mine.jpg) no-repeat center /
    cover;
  display: flex;
  .user-meta {
    flex: 1;
    display: flex;
    align-items: center;
    .avatar {
      width: 85px;
      height: 85px;
      border-radius: 50%;
      overflow: hidden;
      margin-left: 60px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    h4 {
      padding-left: 15px;
      font-size: 18px;
      font-weight: normal;
      color: white;
    }
  }
}
</style>
